export function stickySidebar() {
    
    const stickyEl = $(".sticky-element");
    const parent = stickyEl.closest(".sticky-parent");
    const mediaSection = $(".sticky-parent > .media-section");

    function setSticky() {
        if (window.innerWidth >= 1200 ) {
            
            const itemHeight = stickyEl.innerHeight();
            const parentHeight = parent.innerHeight();
            const parentOffsetLeft = parent.offset().left;
            const parentWidth = parent.innerWidth();
            
            const offsetRight = $("body").width() - (parentWidth + parentOffsetLeft);
    
            if(parentHeight > itemHeight) {
                
                parent.css("min-height", itemHeight);
                
                const scroll = $(window).scrollTop();
                let startPoint = parent.offset().top - 140;
                let endPoint = (parent.offset().top + parentHeight) - (itemHeight + 140);
                
                if (scroll < startPoint) {
                    
                    parent.attr("style", "");
                    stickyEl.removeClass("fixed bottom").attr("style", "") ;
                    
                } else if (scroll >= startPoint && scroll < endPoint) {
                    
                    stickyEl.removeClass("bottom");
                    
                    stickyEl.addClass("fixed").css({
                        right: offsetRight,
                    });
                    
                } else {
                    
                    stickyEl.addClass("bottom").attr("style", "");
                }
            }else{
                stickyEl.attr("style", "position: relative;");
            }
            
        } else {
            stickyEl.removeClass("fixed bottom").attr("style", "");
            parent.attr("style", "");
        }
    }
    
    $(window).on("load scroll resize", setSticky);
}


// WEBPACK FOOTER //
// ./assets/js/modules/sticky-sidebar.js